export const visaServices = [
  {
    id: 1,
    title: 'Visit/Tourist Visa',
    description: 'Perfect for leisure travel and family visits. We handle documentation and application process for tourist visas to popular destinations.',
    category: 'tourist',
    accent: 'accent-purple',
    duration: '2-4 weeks',
    countries: ['USA', 'UK', 'Canada', 'Schengen', 'Australia']
  },
  {
    id: 2,
    title: 'Study Visa',
    description: 'Comprehensive support for students pursuing education abroad. From university selection to visa approval.',
    category: 'study',
    accent: 'accent-blue',
    duration: '4-8 weeks',
    countries: ['USA', 'UK', 'Canada', 'Australia', 'New Zealand']
  },
  {
    id: 3,
    title: 'PR Visa',
    description: 'Permanent residency solutions for skilled professionals. Expert guidance through immigration pathways.',
    category: 'immigration',
    accent: 'accent-orange',
    duration: '6-12 months',
    countries: ['Canada', 'Australia', 'New Zealand', 'Germany']
  },
  {
    id: 4,
    title: 'Dependent Visa',
    description: 'Reunite with your family abroad. We facilitate spouse, children, and parent dependent visas.',
    category: 'family',
    accent: 'accent-pink',
    duration: '3-6 weeks',
    countries: ['USA', 'UK', 'Canada', 'Australia', 'UAE']
  },
  {
    id: 5,
    title: 'B1/B2 USA Visa',
    description: 'Business and tourist visa for USA. Expert interview preparation and documentation support.',
    category: 'usa',
    accent: 'accent-green',
    duration: '3-5 weeks',
    countries: ['USA']
  },
  {
    id: 6,
    title: 'Interview Scheduling',
    description: 'Fast-track your visa interview dates. We help secure earlier appointment slots for urgent travel.',
    category: 'support',
    accent: 'accent-grey',
    duration: '1-2 weeks',
    countries: ['USA', 'UK', 'Schengen']
  }
];

export const processSteps = [
  {
    step: '01',
    title: 'Initial Consultation',
    description: 'Free consultation to understand your visa requirements and assess eligibility.'
  },
  {
    step: '02',
    title: 'Documentation',
    description: 'Complete guidance on required documents and assistance with preparation.'
  },
  {
    step: '03',
    title: 'Application Filing',
    description: 'Expert filing of your visa application with attention to every detail.'
  },
  {
    step: '04',
    title: 'Interview Prep',
    description: 'Mock interviews and preparation tips to boost your confidence.'
  },
  {
    step: '05',
    title: 'Visa Approval',
    description: 'Follow-up support until you receive your visa approval.'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    location: 'Mumbai',
    visa: 'Canada PR Visa',
    rating: 5,
    text: 'Visaasure made my Canada PR journey incredibly smooth. Their team handled every detail professionally, and I got my approval within 8 months!',
    date: 'March 2024'
  },
  {
    id: 2,
    name: 'Rajesh Kumar',
    location: 'Mumbai',
    visa: 'USA B1/B2 Visa',
    rating: 5,
    text: 'Excellent service! They prepared me thoroughly for the interview and I got my 10-year USA visa on the first attempt. Highly recommended!',
    date: 'February 2024'
  },
  {
    id: 3,
    name: 'Anjali Patel',
    location: 'Mumbai',
    visa: 'UK Study Visa',
    rating: 5,
    text: 'From university selection to visa approval, Visaasure guided me at every step. Now pursuing my Masters in London. Thank you!',
    date: 'January 2024'
  },
  {
    id: 4,
    name: 'Vikram Singh',
    location: 'Mumbai',
    visa: 'Australia Tourist Visa',
    rating: 5,
    text: 'Quick and efficient service. Got my tourist visa approved in just 2 weeks. Professional team that knows what they are doing.',
    date: 'April 2024'
  }
];

export const stats = [
  { number: '5000+', label: 'Visas Processed' },
  { number: '98%', label: 'Success Rate' },
  { number: '15+', label: 'Years Experience' },
  { number: '50+', label: 'Countries Covered' }
];

export const contactInfo = {
  phone: '+91 98765 43210',
  email: 'info@visaasure.com',
  address: 'Office 301, Raheja Chambers, Nariman Point, Mumbai - 400021, India',
  whatsapp: '+91 98765 43210',
  hours: 'Mon-Sat: 10:00 AM - 7:00 PM'
};